import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  container: {
    ...dFlex('unset', 'unset'),
    flexDirection: 'column',
    gap: '8px',
  },
  button: {
    padding: '8px',
    borderRadius: theme.borderRadius.md,
    border: `2px solid ${theme.background.b2}`,
    background: theme.background.b2,
    ...dFlex('space-between', 'center'),

    '&:hover': {
      background: theme.secondary.s5,
      border: `2px solid ${theme.secondary.s5}`,
    },

    '& .MuiSvgIcon-root': {
      color: theme.primary.p3,
      width: 22,
    },

    '&:disabled': {
      opacity: 0.4,
      pointerEvents: 'none',
    },
  },
  activeButton: {
    border: `2px solid ${theme.primary.p3}`,

    '&:hover': {
      background: theme.secondary.s5,
      border: `2px solid ${theme.primary.p3}`,
    },
  },
  row: {
    ...dFlex('unset', 'center'),
    gap: '16px',
  },
  tag: {
    background: theme.accent.a1,
    borderRadius: theme.borderRadius.sm,
    padding: '4px 8px',
  },
  logo: {
    borderRadius: '8px',
    width: '48px !important',
    height: '48px !important',
  },
}));

export default useStyles;
